import api from 'api/axiosInstance';

const getRepoFilters = (): Promise<any> =>
  api.get('/v2/repository-documents/filters');

export default getRepoFilters;
